import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";

export const fetchCancelHistory = createAsyncThunk(
  "cancel/fetchCancelHistory",
  async ({ fromDate, toDate, bookingRefNo,intBookingType=2,INTCREATEDBY } = {}, { rejectWithValue }) => {
    try {
      let url = `${REACT_APP_API_URL}api/dashboard/admin/cancel-history`;

      const params = new URLSearchParams();
      params.append("intBookingType", intBookingType);
      if (INTCREATEDBY) params.append("INTCREATEDBY", INTCREATEDBY);
      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);
      if (bookingRefNo) params.append("bookingRefNo", bookingRefNo);

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const response = await axios.get(url);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch cancel history");
    }
  }
);




// Create Redux slice
const cancelSlice = createSlice({
  name: "cancel",
  initialState: {
    data: [],    
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCancelHistory.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCancelHistory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
        state.error = null;  
      })
      .addCase(fetchCancelHistory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;  
      });     
     
  },
});

// Export reducer
export default cancelSlice.reducer;